const en = {
  header: {
    acceuil: 'Home',
    aProposDuCentre: 'About the center',
    demandeSalle: 'Room request',
    nousContacter: 'Contact us',
    lang: 'Français',
    // portail: 'Room booking portal',
    // portailOtherLang: 'Portail de résérvation de salle',
    portail: 'Marrakesh training center',
    portailOtherLang: 'M.T.C',
  },
  accueil: {
    landingTitle: 'Center for Simulation and Innovation in Health Sciences',
    landingSubtitle: 'We offer an immersive and realistic training environment with advanced technologies and simulated clinical scenarios.',
    buttonLanding: 'about Us',
    procedure: 'Procedure',
    demandeReservationSalle: 'Room booking request',
    suivreEtatDemande: 'Track your request status',
    confirmationDemande: 'Confirmation of your presence',
    commentSimulationPeutAider: 'How can simulation help you?',
    developpezCompetence: 'Develop clinical skills safely',
    experienceApprentissage: 'Provide a more engaging learning experience',
    encouragezInteractivite: 'Encourage interactivity and teamwork',
  },
  aproposCentre: {
    aproposCentre: 'About the center:',
    aproposCentreContent: 'Welcome to the Center for Simulation and Innovation in Health Sciences, a place dedicated to excellence in training and research in the field of health sciences. Our center offers an immersive and realistic training environment with advanced technologies and simulated clinical scenarios.',
    notreMission: 'Our Mission:',
    notreMissionContent: 'Our mission is to train the healthcare professionals of tomorrow by providing them with the skills necessary to meet real-world challenges. We believe that practice in a controlled and safe environment not only improves technical skills but also enhances communication, teamwork, and decision-making under pressure.',
    nosInstallations: 'Our Facilities:',
    nosInstallationsItem1: 'High-Fidelity Simulators: Use of sophisticated mannequins that replicate real physiological and pathological conditions.',
    nosInstallationsItem2: 'Immersive Scenarios: Creation of realistic clinical scenarios for intensive hands-on training.',
    nosInstallationsItem3: 'Advanced Technologies: Integration of virtual and augmented reality for an enhanced learning experience.',
    nosInstallationsItem4: 'Research Laboratories: Facilitating innovative research in simulation techniques and medical education.',
    revenirPageAccueil: 'Return to the homepage',
  },
  nousContacter: {
    nousContacter: 'Contact us:',
    nomPrenom: 'Name',
    numeroTelephone: 'Phone number',
    objet: 'Subject',
    message: 'Message',
    envoyer: 'Send',
    messageSuccess : 'your message has been sent successfully',
  },
  reservationSalle: {
    demandeReservationSalle: 'Room booking request',
    suivreEtatDemande: 'Track your request status',
    confirmationDemande: 'Confirmation of your presence',
    cin: 'CIN',
    departement: 'Department',
    nomPrenomFormateur: 'Instructor\'s name',
    nomPrenomAssistantFormateur: 'Assistant instructor\'s name',
    programmeFormation: 'Training program',
    materiel: 'Desired educational material',
    consommables: 'Consumables',
    nombreParticipant: 'Number of participants',
    typeApprentis: 'Type of trainees',
    typeApprentisItems: ['External', 'Resident doctors', 'Intern doctors'],
    choisirDateReservationSalle: 'Choose the room booking date:',
    annee: 'Year',
    mois: 'Month',
    moisItems: [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ],
    confirmer: 'Confirm',
    numeroDemande: 'Request number',
    consulterEtatDemande: 'Check the status of my request',
    oublierNumeroDemandeInfo: 'If you have forgotten your request number, please contact the simulation center administrative team or contact us via the dedicated page',
    faireAutreDemande: 'Make another room booking request',
    annulerDemande: 'I cancel my request',
    confirmerPresence: 'I confirm my presence',
    successDemande: 'Your request has been successfully recorded',
    votreDemandeNumero: 'Your request number',
    enCoursTraitement: 'is being processed',
    information: '\nInformation: ',
    rejete: 'has been rejected. ',
    statutDialogTitle: 'Request number:',
    statutDialgoContent: 'Please note this number to check your request next time',
    cinNumeroDemandeIncorrecte: 'cin or request number is incorrect',
    votreDemandeReservationSalle: 'Your room reservation request for',
    demandeAccepted: 'has been accepted, please confirm your attendance',
    confirmationPresence: 'Presence confirmation:',
    annulationDemande: 'Request cancellation:',
    presenceEnregistre: 'Your presence has been successfully recorded',
    demandeAnnule: 'Your request has been successfully canceled',
    demandeCanceled: 'This request has been cancelled. Please create another',
    inputError: 'Please correct the errors',
  },
  firstWorldCup: {
    jour: 'D',
    heure: 'H',
    minute: 'Min',
    seconde: 'S',
    alaune: 'Headlines',
    worldcup: 'WORLDCUP IN PEDIATRIC SIMULATION',
    dateWorldcup: 'From July 3-6, 2025',
    firstEdition: 'First Edition Marrakech',
    enSavoirPlus: 'Learn more about the event',
    participerEvent: 'Participate in the event',
    soumission: 'Submission',
    inscription: 'Inscription',
    inscriptionNotStudent: 'Registration (Resident, paramedical, specialist)',
    inscriptionStudentSpectateur: 'Spectator',
    typeParticipation: 'Type of participation',
    typeParticipationItems: ['Participant', 'Spectator'],
    inscriptionStudentAttelier: 'Workshop',
    inscriptionStudentCompetition: 'Competition',
    participerStudentEvent: 'Participate in the event as a student',
    inscriptionStudent: 'Registration (Student)',
    soumissionSuccess: 'Your submission has been successfully received.',
    soumissionError: 'Please correct the errors.',
    soumissionTitle: 'Submit your contribution and share your innovations in medical simulation:',
    titre: 'Title',
    auteur: 'Author',
    coAuteur: 'Co-author',
    typeSoumission: 'Submission type',
    email: 'Email',
    specialite: 'Specialty',
    professionItems: ['Student', 'Resident', 'Specialist', 'Paramedical'],
    inscriptionContent: [
      'Your registration has been successfully completed!',
      'We have sent you an email containing all the necessary information to finalize your registration, including payment details. Please check your inbox (and possibly your spam folder) to access this information.',
      'If you have any questions or encounter any difficulties, do not hesitate to contact us.',
      'Thank you and see you soon!'
    ],
    soumissionContent: [
      'Your submission has been successfully received!',
      'We have sent you an email containing all the necessary information to finalize your submission, including payment details. Please check your inbox (and possibly your spam folder) to access this information.',
      'If you have any questions or encounter any difficulties, please do not hesitate to contact us.',
      'Thank you and see you soon!'
    ],
    typeSoumissionItems: ['Oral communication', 'Poster presentation', 'Scenario'],
    accord: 'Alright',
    resume: 'Abstract',
    envoyer: 'Send',
    inscriptionError: 'Please correct the errors',
    inscriptionSuccess: 'Your registration has been successfully submitted.',
    inscriptionTitle: 'Register for the competition and showcase your talent in medical simulation!',
    tel: 'Phone number',
    inscrir: 'Register',
    titleEvent: 'FIRST WORLDCUP IN PEDIATRIC SIMULATION',
    aproposEvent: 'About the event',
    aproposContentEvent: 'Join the First Worldcup of Pediatric Simulation! A unique competition bringing together the best talents in pediatric simulation. Don\'t miss this exceptional event!',
    dateHeureEvent: 'Date and time of the event',
    dateHeureContentEvent: 'From July 3rd to 6th, 2025',
    comiteOrganisationEvent: 'Organizing committee',
    comiteOrganisationContentEvent: 'Prof. Nadia El Idrissi Slitine',
    programmeEvent: 'Program',
    previousDay: 'Previous day',
    nextDay: 'Next day',
    locationEvent: 'Location',
    locationContentEvent: 'Faculty of Medicine and Pharmacy of Marrakech',
    messagePlusLimirWord: 'The abstract must not exceed 500 words.',
    telechargerAffiche: 'Download the poster',
    pays: 'Country',
    paysItems: ['Morocco', 'Other'],
    ville: 'City',
    nationalite: 'Continent',
    nationaliteItems: ['Africa', 'Europe', 'America', 'Asia'],
    profession: 'Category',
    nom1: 'Full name of the team representative',
    nom2: 'Full name of the second participant',
    nom3: 'Full name of the third participant',
    nom4: 'Full name of the fourth participant',
    coach: 'Full name Coach'
  },
  footer: {
    aProposDuCentre: 'About the center',
    reserverSalle: 'Book a room',
    consulterEtatDemande: 'Check the status of your request',
    nousContacter: 'Contact us',
  },
}

export {en};